export default __webpack_public_path__ + "static/media/ht-logo.1684e4f9.png";